export default {
  from: "من",
  to: "إلى",
  fromDate: "من تاريخ",
  toDate: "إلى تاريخ",
  getData: "جلب البيانات",
  loading: "جاري التحميل...",
  noDataHere: "لا يوجد بيانات هنا في هذه الفترة",
  departmentPerformance: "أداء الأقسام",
};

